"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declareComponent = declareComponent;
/**
 * Define a custom element if it is not already defined.
 * @param name The custom element name for the component
 * @param component The component to assign to the name
 */
function declareComponent(name, component) {
    if (globalThis.customElements && !(globalThis === null || globalThis === void 0 ? void 0 : globalThis.customElements.get(name))) {
        globalThis.customElements.define(name, component);
    }
}
